import React, { useEffect, useState } from "react";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import BaseLayout from "../../layout/BaseLayout";
import Snackbar from "@mui/material/Snackbar";
import Pagination from "@mui/material/Pagination";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DatePicker, { ReactDatePicker } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { getListeServiceEtablissement } from "../../services/tarifs/TarifsRequest";
import { getListeNiveauEtudePagination } from "../../services/niveau-etude/NiveauEtudeRequest";
import { getListeAnneeAcademiquePagination } from "../../services/annee-academique/AnneeAcademiqueRequest";
import {
  getListeEleveParAnnee,
  getListeServiceAssocieParEleveParAnnee,
} from "../../services/eleve/EleveRequest";
import {
  enregistrerPaiementEleve,
  exportDesRapportJournalierPdf,
  exportToutPaiement,
  exportToutPaiementPdf,
  getLeResteApayer,
  getListeDeToutLesPaiements,
  totalPaiment,
} from "../../services/paiement/PaiementRequest";
import SelectSearch from "react-select-search";
import "react-select-search/style.css";
import { useNavigate } from "react-router-dom";

const Paiement = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
    pagePagination: 1,
  });
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [loadingData, setLoadingData] = useState(true);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [desactiveLoading, setDesactiveLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [paiementListe, setPaiementListe] = useState([]);
  const [serviceListe, setServiceListe] = useState([]);
  const [eleveListe, setEleveListe] = useState([]);
  const [niveauEtudeListe, setNiveauEtudeListe] = useState([]);
  const [anneeScolaireListe, setAnneeScolaireListe] = useState([]);
  const [paiementInfo, setPaiementInfo] = useState(null);

  const [etablissement, setEtablissement] = useState("");
  const [annee, setAnnee] = useState("");
  const [niveau, setNiveau] = useState("");
  const [service, setService] = useState("");
  const [montant, setMontant] = useState("");
  const [eleve, setEleve] = useState("");
  const [modePaiement, setModePaiement] = useState("");
  const [montantRestant, setMontantRestant] = useState("");
  const [totalPaiement, setTotalPaiement] = useState("");
  const [datePaiement, setDatePaiement] = useState(new Date());
  const [montantTotalPaiement, setMontantTotalPaiement] = useState("");

  const { vertical, horizontal } = snackbarPosition;

  const codeEntite = localStorage.getItem("entiteSchoolCode");

  const dateOption = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
  };

  const searchService = () => {
    setSearchLoading(true);
    const start = startDate.toLocaleDateString().split("/").join("-");
    const end = endDate.toLocaleDateString().split("/").join("-");
    getListeDeToutLesPaiements(
      pageQuery.page,
      pageQuery.size,
      searchTerm,
      niveau,
      service,
      start,
      end
    )
      .then((res) => {
        setSearchLoading(false);
        setPaiementListe(res.data.donnee.paiements);
        setMontantTotalPaiement(
          res.data.donnee && res.data.donnee.montantpaiements !== 0
            ? res.data.donnee.montantpaiements
            : "0"
        );
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setSearchLoading(false);
        console.log("api error", err);
      });
  };

  const modalDesactive = (service) => {
    setPaiementInfo(service);
    document.getElementById("desactive-warning").click();
  };

  const modalCreateAutreCanal = () => {
    document.getElementById("ajout-autre-canal").click();
    clearFormulaireEnregistrementPaiement();
  };

  const modalEditPaiement = (paiement) => {
    document.getElementById("ajout-autre-canal").click();
    setPaiementInfo(paiement);
    setAnnee(
      paiement.eleveServiceMoMo ? paiement.eleveServiceMoMo.annee.id : ""
    );
    setService(
      paiement.eleveServiceMoMo ? paiement.eleveServiceMoMo.serviceMoMo.id : ""
    );
    setMontant(paiement.montant);
    setEleve(
      paiement.eleveServiceMoMo ? paiement.eleveServiceMoMo.eleve.id : ""
    );
    setModePaiement(paiement.modePaiement);
    setMontantRestant("");
    setDatePaiement(new Date(paiement.datePaiement));
    getListeEleveParAnnee(paiement.eleveServiceMoMo.annee.id)
      .then((res) => {
        setLoadingData(false);
        let eleves = [];
        res.data.donnee.eleves.map((item) => {
          eleves.push({
            name: `${item.nom} ${item.prenoms}`,
            value: item.id,
          });
        });

        setEleveListe(eleves);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const clearFormulaireEnregistrementPaiement = () => {
    setPaiementInfo(null);
    setAnnee("");
    setNiveau("");
    setService("");
    setMontant("");
    setEleve("");
    setModePaiement("");
    setMontantRestant("");
    setDatePaiement(new Date());
  };

  const getListeDesPaiementEnregistre = () => {
    setLoadingData(true);
    getListeDeToutLesPaiements(0, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setPaiementListe(
          res.data.donnee.paiements ? res.data.donnee.paiements : []
        );
        setMontantTotalPaiement(
          res.data.donnee && res.data.donnee.montantpaiements !== 0
            ? res.data.donnee.montantpaiements
            : "0"
        );
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const getListeDesService = () => {
    getListeServiceEtablissement()
      .then((res) => {
        setServiceListe(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  };

  const getListeDesNiveauxEtude = () => {
    getListeNiveauEtudePagination(0, 30000)
      .then((res) => {
        setNiveauEtudeListe(res.data.donnee.niveaux);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  };

  const getListeDesAnneeScolaire = () => {
    getListeAnneeAcademiquePagination(0, 30000)
      .then((res) => {
        setAnneeScolaireListe(res.data.donnee.annees);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  };

  const getListeServiceNiveau = (etablissement) => {
    setEtablissement(etablissement);
    setErrorMessage("");

    // getListeEleveParAnnee(etablissement)
    //   .then((res) => {
    //     setLoadingData(false);
    //     let eleves = [];
    //     res.data.donnee.eleves.map((item) => {
    //       eleves.push({
    //         name: `${item.nom} ${item.prenoms}`,
    //         value: item.id,
    //       });
    //     });

    //     setEleveListe(eleves);
    //   })
    //   .catch((err) => {
    //     setLoadingData(false);
    //     console.log("api error", err);
    //   });
  };

  const getListeDesAnneeParEtablissement = (etablissement) => {
    setEtablissement(etablissement);
    setErrorMessage("");

    // getListeEleveParAnnee(etablissement)
    //   .then((res) => {
    //     setLoadingData(false);
    //     let eleves = [];
    //     res.data.donnee.eleves.map((item) => {
    //       eleves.push({
    //         name: `${item.nom} ${item.prenoms}`,
    //         value: item.id,
    //       });
    //     });

    //     setEleveListe(eleves);
    //   })
    //   .catch((err) => {
    //     setLoadingData(false);
    //     console.log("api error", err);
    //   });
  };

  const getListeDesElevesParAnnee = (annee) => {
    setAnnee(annee);
    setErrorMessage("");

    getListeEleveParAnnee(annee)
      .then((res) => {
        setLoadingData(false);
        let eleves = [];
        res.data.donnee.eleves.map((item) => {
          eleves.push({
            name: `${item.nom} ${item.prenoms}`,
            value: item.id,
          });
        });

        setEleveListe(eleves);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const getListeDesServicesParEleve = (eleve) => {
    setEleve(eleve);
    setService("");
    setErrorMessage("");

    getListeServiceAssocieParEleveParAnnee(annee, eleve)
      .then((res) => {
        setLoadingData(false);
        setServiceListe(res.data.donnee);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const getSelectedService = (service) => {
    setService(service);
    const serv = JSON.parse(service);
    setErrorMessage("");

    getLeResteApayer(annee, eleve, serv.id)
      .then((res) => {
        setLoadingData(false);
        setMontantRestant(res.data.donnee);
      })
      .catch((err) => {
        setLoadingData(false);
        setSnackbarOpenError(true);
        if (err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur de récupération du reste à payer");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const ajoutPaiementParEleve = () => {
    setAddLoading(false);

    const serviceElement = JSON.parse(service);
    const dataToSubmit = {
      id: paiementInfo ? paiementInfo.id : "",
      anneeId: annee,
      eleveId: eleve,
      serviceMoMoId: serviceElement.id ? serviceElement.id : service,
      montant: montant,
      modePaiement: modePaiement,
      datePaiement: datePaiement.toISOString(),
    };

    console.log("DA", serviceElement);
    console.log("XXX", dataToSubmit);

    enregistrerPaiementEleve(dataToSubmit)
      .then((res) => {
        setSuccessMessage("Paiement enregistré avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("ajout-autre-canal").click();
        getListeDesPaiementEnregistre();
        getTotalPaiement();
        clearFormulaireEnregistrementPaiement();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const exportListePaiement = () => {
    setLoadingExport(true);
    const exportParam = {
      dateDebut: formatDate(startDate),
      dateFin: formatDate(endDate),
      param: searchTerm,
      niveauId: niveau,
      serviceId: service,
    };

    exportToutPaiement(exportParam)
      .then((res) => {
        setLoadingExport(false);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        console.log(url);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Liste_paiement.xlsx`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        setLoadingExport(false);
        console.log("api error", err);
      });
  };

  const exportListePaiementPdf = () => {
    setLoadingExport(true);

    const exportParam = {
      dateDebut: formatDate(startDate),
      dateFin: formatDate(endDate),
      param: searchTerm,
      niveauId: niveau,
      serviceId: service,
    };

    exportToutPaiementPdf(exportParam)
      .then((res) => {
        setLoadingExport(false);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        console.log(url);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Liste_paiement.pdf`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        setLoadingExport(false);
        console.log("api error", err);
      });
  };

  const exportRapportJournalierPdf = () => {
    setLoadingExport(true);

    const exportParam = {
      dateDebut: formatDate(startDate),
      dateFin: formatDate(endDate),
      param: searchTerm,
      niveauId: niveau,
      serviceId: service,
    };

    exportDesRapportJournalierPdf(exportParam)
      .then((res) => {
        setLoadingExport(false);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        console.log(url);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Rapport_journalier.pdf`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        setLoadingExport(false);
        console.log("api error", err);
      });
  };

  const getTotalPaiement = () => {
    totalPaiment()
      .then((res) => {
        setTotalPaiement(res.data.donnee);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  };

  const supprimerService = () => {};

  const changerEtatService = () => {};

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value,
    }));
    getListeDeToutLesPaiements(
      value - 1,
      pageQuery.size,
      searchTerm,
      niveau,
      service,
      formatDate(startDate),
      formatDate(endDate)
    )
      .then((res) => {
        setLoadingData(false);
        setPaiementListe(res.data.donnee.paiements);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const TableElement = ({ paiement }) => {
    return (
      <tr>
        <td className="px-4">
          {paiement.momoFinancialTransactionId
            ? `${paiement.momoFinancialTransactionId}`
            : ""}
        </td>
        {codeEntite === "HOSPITAL" ? (
          <td className="px-4">
            {paiement.nomClient ? paiement.nomClient : ""}
          </td>
        ) : null}
        {codeEntite === "HOSPITAL" ? (
          <td className="px-4">{paiement.numero ? paiement.numero : ""}</td>
        ) : null}

        {codeEntite === "SCHOOL" ? (
          <td className="px-4">
            {paiement.eleveServiceMoMo
              ? `${paiement.eleveServiceMoMo.eleve.nom} ${paiement.eleveServiceMoMo.eleve.prenoms}`
              : ""}
          </td>
        ) : null}
        {codeEntite === "SCHOOL" ? (
          <td className="px-4">
            {paiement.eleveServiceMoMo
              ? `${paiement.eleveServiceMoMo.eleve.matricule}`
              : ""}
          </td>
        ) : null}
        {codeEntite === "SCHOOL" ? (
          <td className="px-4">
            {paiement.eleveServiceMoMo
              ? paiement.eleveServiceMoMo.serviceMoMo.designation
              : ""}
          </td>
        ) : null}
        <td className="px-4">{paiement.montant} FCFA</td>
        {/* <td className="px-4">
          {paiement.modePaiement === "ORANGE_MONEY"
            ? "Orange Money"
            : paiement.modePaiement === "MOOV_MONEY"
            ? "Moov Money"
            : paiement.modePaiement === "WAVE"
            ? "Wave"
            : paiement.modePaiement === "ESPECE"
            ? "Espèce"
            : "Autre"}
        </td> */}
        <td className="px-4">
          {new Date(paiement.datePaiement).toLocaleDateString(
            "fr-CI",
            dateOption
          )}
        </td>
        {/* <td className="w-40 px-4">
          <div className="flex items-center gap-x-3">
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => modalEditPaiement(paiement)}
            >
              <EditIcon />
            </button>
          </div>
        </td> */}
      </tr>
    );
  };

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();

    const formattedDate = [day, month, year].join("-");
    return formattedDate;
  };

  function formatCurrency(number) {
    // Check if the Intl object is supported in the user's browser
    if (typeof Intl === "object" && typeof Intl.NumberFormat === "function") {
      // Get the user's locale from the browser
      const userLocale = navigator.language || navigator.userLanguage;

      // Format the number to currency based on the user's locale
      return new Intl.NumberFormat(userLocale, {
        style: "decimal",
        currency: "XOF", // Replace with the appropriate currency code based on the user's location
      }).format(number);
    } else {
      // Fallback for browsers that do not support the Intl object
      // Replace this with your custom formatting logic if needed
      return number.toFixed(2); // Formats the number as USD currency
    }
  }

  useEffect(() => {
    getListeDeToutLesPaiements(pageQuery.page, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setPaiementListe(
          res.data.donnee.paiements ? res.data.donnee.paiements : []
        );
        setMontantTotalPaiement(
          res.data.donnee && res.data.donnee.montantpaiements !== 0
            ? res.data.donnee.montantpaiements
            : "0"
        );
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient");
          navigate("/login");
        }
      });

    getTotalPaiement();
    getListeDesService();
    getListeDesNiveauxEtude();
    getListeDesAnneeScolaire();
  }, []);

  return (
    <BaseLayout>
      <div className="w-11/12 lg:w-10/12 mx-auto pt-32">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl text-black font-bold">Paiements</h1>
        </div>
        <div className="mt-12 pb-14">
          <div className="mb-5 flex items-end justify-between">
            <div className="flex items-end gap-x-2">
              <div>
                <label className="label">
                  <span className="label-text">Rechercher</span>
                </label>
                <div className="flex items-center gap-x-2">
                  <input
                    type="text"
                    disabled={searchLoading}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Rechercher un élément"
                    className="input input-bordered w-40"
                  />
                </div>
              </div>
              <div>
                <label className="label">
                  <span className="label-text">Date début</span>
                </label>
                <DatePicker
                  disabled={searchLoading}
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  dateFormat="dd/MM/yyyy"
                  className="z-50 w-32 px-3 py-2.5 rounded-lg border border-gray-300"
                />
              </div>
              <div>
                <label className="label">
                  <span className="label-text">Date fin</span>
                </label>
                <DatePicker
                  disabled={searchLoading}
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  dateFormat="dd/MM/yyyy"
                  className="z-50 w-32 px-3 py-2.5 rounded-lg border border-gray-300"
                />
              </div>
              {codeEntite === "SCHOOL" ? (
                <div>
                  <label className="label">
                    <span className="label-text">Service</span>
                  </label>
                  <select
                    disabled={searchLoading}
                    value={service}
                    onChange={(e) => setService(e.target.value)}
                    className="select select-bordered w-full font-normal"
                  >
                    <option value="" disabled selected>
                      Choisir un service
                    </option>
                    <option value="">Tous</option>
                    {serviceListe.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.designation}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}
              {codeEntite === "SCHOOL" ? (
                <div>
                  <label className="label">
                    <span className="label-text">Niveau étude</span>
                  </label>
                  <select
                    value={niveau}
                    disabled={searchLoading}
                    onChange={(e) => setNiveau(e.target.value)}
                    className="select select-bordered font-medium w-full max-w-xs"
                  >
                    <option value="" disabled selected>
                      choisir un niveau
                    </option>
                    <option value="">Tous</option>
                    {niveauEtudeListe.map((item) => (
                      <option value={item.id} key={item.id}>
                        {item.designation}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}
              <button
                disabled={searchLoading}
                className="w-14 h-11 bg-stone-900 text-white rounded-md flex items-center justify-center"
                onClick={searchService}
              >
                {!searchLoading ? (
                  <SearchIcon />
                ) : (
                  <TailSpin
                    height="25"
                    width="25"
                    color="#fff"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={searchLoading}
                  />
                )}
              </button>
            </div>
            <div className="flex items-center gap-x-2">
              {loadingExport ? (
                <button
                  className="bg-momo-blue w-20 py-2.5 rounded-md text-white font-bold flex items-center justify-center mb-1"
                  disabled
                >
                  <ThreeDots
                    height="20"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={true}
                  />
                </button>
              ) : (
                <div className="dropdown dropdown-bottom dropdown-end">
                  <label
                    tabIndex={0}
                    className="bg-momo-blue w-20 py-2 rounded-md text-white font-bold flex items-center justify-center mb-1 cursor-pointer"
                  >
                    Export
                  </label>
                  <ul
                    tabIndex={0}
                    className="dropdown-content menu p-2 shadow bg-base-100 rounded-md w-64"
                  >
                    <button
                      className="h-11 flex items-center hover:bg-gray-100 rounded-md px-3"
                      disabled={loadingExport}
                      onClick={exportListePaiement}
                    >
                      <p className="font-bold">
                        <span>Paiements (Excel)</span>
                      </p>
                    </button>
                    <button
                      className="h-11 flex items-center hover:bg-gray-100 rounded-md px-3"
                      disabled={loadingExport}
                      onClick={exportListePaiementPdf}
                    >
                      <p className="font-bold">
                        <span>Paiements (PDF)</span>
                      </p>
                    </button>
                    <button
                      className="h-11 flex items-center hover:bg-gray-100 rounded-md px-3"
                      disabled={loadingExport}
                      onClick={exportRapportJournalierPdf}
                    >
                      <p className="font-bold text-left">
                        <span>Rapport journalier (PDF)</span>
                      </p>
                    </button>
                  </ul>
                </div>
              )}

              {/* {codeEntite === "SCHOOL" ? (
                <button
                  className="bg-momo-blue w-20 py-2 rounded-md text-white font-bold flex items-center justify-center mb-1"
                  onClick={modalCreateAutreCanal}
                >
                  <span>Ajouter</span>
                </button>
              ) : null} */}
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="table table-compact w-full mb-2">
              <thead>
                <tr>
                  <th className="capitalize py-4 px-4">Id transaction</th>
                  {codeEntite === "HOSPITAL" ? (
                    <th className="capitalize py-4 px-4">Nom client</th>
                  ) : null}
                  {codeEntite === "HOSPITAL" ? (
                    <th className="capitalize py-4 px-4">Numéro client</th>
                  ) : null}
                  {codeEntite === "SCHOOL" ? (
                    <th className="capitalize py-4 px-4">Elève</th>
                  ) : null}
                  {codeEntite === "SCHOOL" ? (
                    <th className="capitalize py-4 px-4">Matricule élève</th>
                  ) : null}
                  {codeEntite === "SCHOOL" ? (
                    <th className="capitalize py-4 px-4">Service</th>
                  ) : null}
                  <th className="capitalize py-4 px-4">Montant</th>
                  {/* <th className="capitalize py-4 px-4">Canal paiement</th> */}
                  <th className="capitalize py-4 px-4">Date de paiement</th>
                  {/* <th className="capitalize py-4 px-4">Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {!loadingData && paiementListe.length > 0 ? (
                  <>
                    {paiementListe.map((item) => (
                      <TableElement key={item.id} paiement={item} />
                    ))}
                    <tr>
                      <td colSpan={codeEntite === "SCHOOL" ? 6 : 5}>
                        <div className="w-full h-3 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center"></div>
                      </td>
                    </tr>
                    <tr>
                      {/* <td className="px-4"></td> */}
                      {codeEntite === "SCHOOL" ? (
                        <td className="px-4"></td>
                      ) : null}
                      {codeEntite === "SCHOOL" ? (
                        <td className="px-4"></td>
                      ) : null}
                      {codeEntite === "SCHOOL" ? (
                        <td className="px-4"></td>
                      ) : null}
                      {codeEntite === "HOSPITAL" ? (
                        <td className="px-4"></td>
                      ) : null}
                      {codeEntite === "HOSPITAL" ? (
                        <td className="px-4"></td>
                      ) : null}
                      {codeEntite === "SCHOOL" ? (
                        <td className="px-4 text-base text-red-600 font-bold">
                          Montant total paiement
                        </td>
                      ) : (
                        <td className="px-4 text-base text-red-600 font-bold">
                          Montant total paiement
                        </td>
                      )}
                      <td className="px-4 text-black text-base font-bold">
                        {formatCurrency(montantTotalPaiement)} FCFA
                      </td>
                      {codeEntite === "SCHOOL" || codeEntite === "HOSPITAL" ? (
                        <td className="px-4"></td>
                      ) : (
                        <td className="px-4"></td>
                      )}
                    </tr>
                  </>
                ) : !loadingData && paiementListe.length === 0 ? (
                  <tr>
                    <td colSpan={codeEntite === "SCHOOL" ? 6 : 5}>
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <ErrorOutlineIcon />
                        <p className="font-medium text-red-500">
                          Aucun élément trouvé
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && paiementListe.length === 0 ? (
                  <tr>
                    <td colSpan={codeEntite === "SCHOOL" ? 6 : 5}>
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={codeEntite === "SCHOOL" ? 6 : 5}>
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex justify-end">
              <Pagination
                count={pageQuery.nombrePage}
                page={pageQuery.pagePagination}
                variant="outlined"
                shape="rounded"
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* SUPPRIMER SERVICE */}
      <input type="checkbox" id="delete-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-2xl text-center text-red-500">
            Attention !
          </h3>
          <p className="text-lg text-center py-4">
            Cette action est irréversible
          </p>
          <div className="modal-action flex justify-center gap-x-5">
            {!deleteLoading ? (
              <label
                id="delete-warning-btn"
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={deleteLoading}
              className="bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={supprimerService}
            >
              {!deleteLoading ? (
                <span>Supprimer</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={deleteLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* DESACTIVER UTILISATEUR */}
      <input type="checkbox" id="desactive-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3
            className={
              paiementInfo && paiementInfo.enabled
                ? "font-bold text-2xl text-center text-red-500"
                : "font-bold text-2xl text-center text-green-500"
            }
          >
            {paiementInfo && paiementInfo.enabled
              ? "Désactiver ce service"
              : "Activer ce service"}
          </h3>
          <div className="modal-action flex justify-center gap-x-5">
            {!desactiveLoading ? (
              <label
                id="desactive-warning-btn"
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={desactiveLoading}
              className={
                paiementInfo && paiementInfo.enabled
                  ? "bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
                  : "bg-green-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              }
              onClick={changerEtatService}
            >
              {!desactiveLoading ? (
                <>
                  {paiementInfo && paiementInfo.enabled ? (
                    <span>Désactiver</span>
                  ) : (
                    <span>Activer</span>
                  )}
                </>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={desactiveLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* MODAL AJOUT AUTRE CANAL */}
      <input type="checkbox" id="ajout-autre-canal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">
            {paiementInfo === null
              ? "Paiement via autre canal"
              : "Modifier ce paiement"}
          </h3>
          <div className="py-5">
            {/* <div>
              <label className="label">
                <span className="label-text">Etablissements</span>
              </label>
              <select
                disabled={addLoading}
                value={etablissement}
                onChange={(e) => getListeDesAnneeParEtablissement(e.target.value)}
                className="select select-bordered w-full font-normal"
              >
                <option value="" disabled selected>
                  Choisir un établissement
                </option>
                {anneeScolaireListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div> */}
            <div>
              <label className="label">
                <span className="label-text">Année academique</span>
              </label>
              <select
                disabled={addLoading}
                value={annee}
                onChange={(e) => getListeDesElevesParAnnee(e.target.value)}
                className="select select-bordered w-full font-normal"
              >
                <option value="" disabled selected>
                  Choisir un année
                </option>
                {anneeScolaireListe.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">
                <span className="label-text">Elève</span>
              </label>
              <SelectSearch
                options={eleveListe}
                value={eleve}
                name="language"
                placeholder="Rechercher un élève"
                search
                onChange={(e) => getListeDesServicesParEleve(e)}
              />
            </div>
            <div>
              <label className="label">
                <span className="label-text">Choix du service</span>
              </label>
              <select
                disabled={addLoading}
                value={service}
                onChange={(e) => getSelectedService(e.target.value)}
                className="select select-bordered w-full font-normal"
              >
                <option value="" disabled selected>
                  Choisir un service
                </option>
                {serviceListe.map((item) => (
                  <option value={JSON.stringify(item)} key={item.id}>
                    {item.designation}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-center gap-x-4">
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Montant payé (FCFA)</span>
                </label>
                <input
                  disabled={addLoading}
                  value={montant}
                  onChange={(e) => setMontant(e.target.value)}
                  type="text"
                  placeholder="3214"
                  className="input input-bordered w-full"
                />
              </div>
              <div className="w-full">
                <label className="label">
                  <span className="label-text">Canal de paiement</span>
                </label>
                <select
                  disabled={addLoading}
                  value={modePaiement}
                  onChange={(e) => setModePaiement(e.target.value)}
                  className="select select-bordered w-full font-normal"
                >
                  <option value="" disabled selected>
                    Choisir un canal
                  </option>
                  <option value="ORANGE_MONEY">Orange Money</option>
                  <option value="MOOV_MONEY">Moov Money</option>
                  <option value="WAVE">Wave</option>
                  <option value="ESPECE">Espèce</option>
                  <option value="AUTRE">Autre</option>
                </select>
              </div>
            </div>
            {montantRestant || montantRestant === 0 ? (
              <div className="pt-3 pb-1 pl-1">
                <p className="text-sm text-red-600 font-bold">
                  Montant restant : {montantRestant} FCFA
                </p>
              </div>
            ) : null}
            <div>
              <label className="label">
                <span className="label-text">Date de paiement</span>
              </label>
              <div className="form-datapicker w-full">
                <DatePicker
                  selected={datePaiement}
                  onChange={(date) => setDatePaiement(date)}
                  dateFormat="dd/MM/yyyy"
                  className="z-50 w-full px-3 py-2.5 rounded-lg border border-gray-300"
                />
              </div>
            </div>
          </div>
          <div className="modal-action">
            {!addLoading ? (
              <label
                htmlFor="ajout-autre-canal"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="ajout-autre-canal"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={addLoading}
              className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
              onClick={ajoutPaiementParEleve}
            >
              {!addLoading ? (
                <span>{!paiementInfo ? "Enregistrer" : "Modifier"}</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#000"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={addLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </BaseLayout>
  );
};

export default Paiement;
